export default {"src":"/_next/static/image/public/images/check.942ded6f2026a5c02b4f8a3e7c416d4f.svg","height":25,"width":24};